export enum RoleLevel {
  SUPERADMIN = 500,
  ADMIN = 400,
  MANAGER = 250,
  EDITOR = 200,
  READER = 100,
  NO_ACCESS = 1,
  DELETE = 0, // TODO remove this and rework related logic
}
// bits?
export enum UserCategory {
  SiteUser = 1, // next 2, 4, 8 ...
}

export function roleLevelToString(roleLevel: RoleLevel): string {
  if (roleLevel >= RoleLevel.NO_ACCESS && roleLevel < RoleLevel.READER) {
    return tiStrings.enum.roleLevels.noAccess;
  }
  if (roleLevel >= RoleLevel.READER && roleLevel < RoleLevel.EDITOR) {
    return tiStrings.enum.roleLevels.reader;
  }
  if (roleLevel >= RoleLevel.EDITOR && roleLevel < RoleLevel.MANAGER) {
    return tiStrings.enum.roleLevels.editor;
  }
  if (roleLevel >= RoleLevel.MANAGER && roleLevel < RoleLevel.ADMIN) {
    return tiStrings.enum.roleLevels.manager;
  }
  if (roleLevel >= RoleLevel.ADMIN && roleLevel < RoleLevel.SUPERADMIN) {
    return tiStrings.enum.roleLevels.admin;
  }
  if (roleLevel >= RoleLevel.SUPERADMIN) {
    return tiStrings.enum.roleLevels.superadmin;
  }
  if (roleLevel === RoleLevel.DELETE) {
    return tiStrings.enum.roleLevels.delete;
  }
  if (roleLevel === null) {
    return tiStrings.enum.roleLevels.contact;
  }

  return '';
}
